import * as React from 'react'

import * as ds from '@bob/design-system'
import * as hooks from '@bob/hooks'
import * as logger from '@bob/logger'

type PaginationProps<ITEM> = {
  engine: hooks.useSearchEngine.SearchEngine<ITEM>
}

export function Pagination<ITEM>({
  engine: { ready, result, pagination },
}: PaginationProps<ITEM>): React.ReactElement | null {
  if (result.status === 'request' || !ready) {
    return null
  }

  return (
    <ds.Pagination
      href={(page) => pagination.pageHref(page)}
      onNavigate={() => {
        const anchor = document.getElementById('top')
        if (!anchor) {
          logger.err(`[pagination] Couldn't find an anchor to scroll to`)
          return
        }

        const headerOffset = 85
        const position = anchor.getBoundingClientRect().top + window.pageYOffset - headerOffset
        window.scrollTo({ top: position, behavior: 'smooth' })
      }}
      pageCount={pagination.pages.length}
      selectedPage={pagination.page}
    />
  )
}
